import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ReactComponent as CheckCircleFilled } from 'assets/icons/checkCircleFilled.svg';
import { ReactComponent as BulbFilled } from 'assets/icons/bulbFilled.svg';

export default function MaPrimeAdaptBlock({ couleurMPR }) {
  const pourcentageAides =
    (couleurMPR === 'bleue' && 70) || (couleurMPR === 'jaune' && 50) || 0;

  return (
    <>
      <div
        className={clsx(
          'flex flex-col md:flex-row items-center w-full gap-4 md:gap-4 !mb-5 text-center',
          {
            'md:text-left': pourcentageAides > 0,
          },
        )}
      >
        <h2 className="text-bleu-hellio md:!text-2xl !text-base w-full">
          MaPrimeAdapt’
        </h2>
        {!!pourcentageAides && (
          <p className="md:!text-xl !text-base">
            Bénéficiez jusqu’à{' '}
            <strong>{pourcentageAides}&nbsp;% d’aides</strong> dans la limite de
            22&nbsp;000&nbsp;€&nbsp;HT
          </p>
        )}
      </div>

      <div className="w-full rounded-2xl bg-bleu-hellio-1 !p-5 !mb-5">
        {!!pourcentageAides && (
          <h3 className="!text-gris-hellio !mb-4 !text-base text-left flex">
            <BulbFilled className="!mr-2" />
            Bon à savoir
          </h3>
        )}
        <p className="!text-sm text-gris-hellio text-left">
          {pourcentageAides > 0 ? (
            <>
              MaPrimeAdapt’ peut être cumulée avec d’autres dispositifs d’aides
              tels que les aides locales, la Prestation de Compensation du
              Handicap (PCH), ainsi que les aides à la rénovation énergétique.
            </>
          ) : (
            <>
              La perte d’autonomie ou de mobilité, liée à l’âge ou à un
              handicap, peut rendre nécessaire l’adaptation de votre logement
              afin de continuer à y vivre en toute sécurité et plus longtemps.
            </>
          )}
        </p>
      </div>

      <div className="w-full rounded-2xl bg-vert-agriculture-1 !p-5">
        <h3 className="!text-gris-hellio !mb-4 !text-base text-left flex">
          <CheckCircleFilled className="!mr-2" />
          Bénéfices
        </h3>

        <ul
          className={clsx(
            'text-gris-hellio list-inside text-left !text-sm flex items-start content-start flex-wrap gap-3',
            '[&>li]:bg-white [&>li]:p-3 [&>li]:rounded-full [&>li]:flex',
          )}
        >
          <li>Améliorer votre confort</li>
          <li>Faciliter votre quotidien</li>
          <li>Gagner en autonomie</li>
          <li>Analyser vos habitudes</li>
          <li>Sécuriser votre logement</li>
        </ul>
      </div>
    </>
  );
}
MaPrimeAdaptBlock.propTypes = {
  couleurMPR: PropTypes.string,
};
